document.addEventListener("DOMContentLoaded", () => {
  const newsletterModal = document.getElementById("customNewsletter");
  const newsletterClose = document.getElementById("customNewsletter__close");
  
  const showPopup = () => {
    // Check if popup has been shown today
    const lastShownDate = localStorage.getItem("newsletterPopupLastShown");
    const today = new Date().toDateString();
    
    if (!lastShownDate || lastShownDate !== today) {
      setTimeout(() => {
        newsletterModal.style.display = "block";
      }, 160000); // 1 minutes delay
    }
  };
  
  const closePopup = () => {
    newsletterModal.style.display = "none";
    // Save the date when the popup was closed
    localStorage.setItem("newsletterPopupLastShown", new Date().toDateString());
  };
  
  newsletterClose.addEventListener("click", closePopup);
  
  // Show popup on page load
  showPopup();
});